export const useAvailabilityDetailReportColumns = () => {
  return [
    {
      headerName: 'Unit',
      field: 'unit',
    },
    {
      headerName: 'Employee',
      field: 'employee',
    },
    {
      headerName: 'Availability',
      field: 'availability',
    },
  ];
};

export default useAvailabilityDetailReportColumns;